import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DashBoard from "./pages/DashBoard/DashBoard";
import Login from "./pages/Login/Login";
import ViewReport from "./pages/ViewReport/ViewReport";
import RequireAuth from "./RequireAuth";
import { AuthProvider } from "./auth";
import ViewReportV2 from "./pages/ViewReport/viewReportV2";
import ClinicManagement from "./pages/ClinicManagement/ClinicManagement";
import { useOrgContext } from "./Context/orgContext";
import GeneratePlan from "./pages/GeneratePlan/GeneratePlan";

export const AppRoute = (props) => {
  const { isOrgAdmin } = useOrgContext();

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <RequireAuth>
                <DashBoard />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <DashBoard />
              </RequireAuth>
            }
          />
          <Route
            path="/generate-plan"
            element={
              <RequireAuth>
                <GeneratePlan />
              </RequireAuth>
            }
          />
          <Route
            path="/view-report/:userId/:sessionId"
            element={
              <RequireAuth>
                <ViewReport />
              </RequireAuth>
            }
          />
          <Route
            path="/user-data/:userId/"
            element={
              <RequireAuth>
                <ViewReportV2 />
              </RequireAuth>
            }
          />
          {
            isOrgAdmin &&
            <Route
              path="/clinicManagement"
              element={
                <RequireAuth>
                  <ClinicManagement />
                </RequireAuth>
              }
            />
          }
        </Routes>
      </Router>
    </AuthProvider>
  );
};
